import 'cookieconsent/build/cookieconsent.min.css'
import 'cookieconsent'
import {Capacitor} from '@capacitor/core'

const LS_KEY = 'rockease_cookie_consent'

export class CookieConsentService {
  private matomoScriptId = 'matomo-script'

  async init(matomoUrl: string, matomoSiteId: string) {
    // On native iOS, cookies don't persist across app restarts — use localStorage instead.
    if (Capacitor.isNativePlatform()) {
      const saved = localStorage.getItem(LS_KEY)
      if (saved === 'allow') {
        this.injectMatomo(matomoUrl, matomoSiteId)
      }
      if (saved !== null) {
        // Consent already recorded — skip the popup entirely.
        return
      }
      // First launch: show popup but persist result in localStorage.
      window.cookieconsent.initialise({
        palette: {
          popup: { background: '#2C4965' },
          button: { background: '#FFED00' }
        },
        theme: 'classic',
        position: 'top-right',
        hidden: true,
        type: 'opt-in',
        content: {
          message: 'Ce site utilise des cookies pour améliorer votre expérience. Vous pouvez accepter, refuser ou gérer vos préférences à tout moment. Vos données restent anonymes.',
          allow: 'Accepter',
          deny: 'Refuser',
          link: '',
          href: '#politique-cookies',
          policy: ''
        },
        onStatusChange: (status: string) => {
          localStorage.setItem(LS_KEY, status)
          if (status === window.cookieconsent.status.allow) {
            this.injectMatomo(matomoUrl, matomoSiteId)
          } else {
            this.removeMatomo()
          }
        }
      })
      return
    }

    // Web: standard cookie-based behaviour.
    window.cookieconsent.initialise({
      palette: {
        popup: { background: '#2C4965' },
        button: { background: '#FFED00' }
      },
      theme: 'classic',
      position: 'top-right',
      hidden: true,
      type: 'opt-in',
      content: {
        message: 'Ce site utilise des cookies pour améliorer votre expérience. Vous pouvez accepter, refuser ou gérer vos préférences à tout moment. Vos données restent anonymes.',
        allow: 'Accepter',
        deny: 'Refuser',
        link: '',
        href: '#politique-cookies',
        policy: ''
      },
      onInitialise: (status: string) => {
        if (status === window.cookieconsent.status.allow) {
          this.injectMatomo(matomoUrl, matomoSiteId)
        }
      },
      onStatusChange: (status: string) => {
        if (status === window.cookieconsent.status.allow) {
          this.injectMatomo(matomoUrl, matomoSiteId)
        } else {
          this.removeMatomo()
        }
      }
    })
  }

  private injectMatomo(matomoUrl: string, matomoSiteId: string) {
    if (document.getElementById(this.matomoScriptId)) return
    const script = document.createElement('script')
    script.id = this.matomoScriptId
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = `
      var _paq = window._paq = window._paq || [];
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u="${matomoUrl}";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '${matomoSiteId}']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
      })();
    `
    document.body.appendChild(script)
  }

  private removeMatomo() {
    const script = document.getElementById(this.matomoScriptId)
    if (script) script.remove()
  }
}